import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Loader2, UserPlus, Download, CheckCircle, Clock } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ReferralsPage() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadReferrals(); }, []);

  const loadReferrals = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('admin_token');
      const res = await axios.get(`${API}/api/admin/referrals/list`, { headers: { Authorization: `Bearer ${token}` } });
      setReferrals(res.data);
    } catch (err) { toast.error('Erro ao carregar indicações'); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-referrals-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2"><UserPlus className="h-6 w-6 text-green-500" />Gestão de Indicações</h1>
          <p className="text-sm text-zinc-400 mt-1">Controle de quem indicou quem na plataforma</p>
        </div>
        <Badge variant="outline" className="text-xs">{referrals.length} indicações</Badge>
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>
      ) : referrals.length === 0 ? (
        <Card className="bg-zinc-900 border-zinc-800"><CardContent className="p-8 text-center text-zinc-500">Nenhuma indicação registrada.</CardContent></Card>
      ) : (
        <Card className="bg-zinc-900 border-zinc-800 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-zinc-800 text-left text-xs text-zinc-400 uppercase">
                  <th className="p-3">Indicador</th>
                  <th className="p-3">Email Indicador</th>
                  <th className="p-3">Indicado</th>
                  <th className="p-3">Email Indicado</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Data</th>
                </tr>
              </thead>
              <tbody>
                {referrals.map((r, i) => (
                  <tr key={r.id || i} className="border-b border-zinc-800/50 hover:bg-zinc-800/30">
                    <td className="p-3 font-medium text-white">{r.referrer_name}</td>
                    <td className="p-3 text-zinc-400">{r.referrer_email}</td>
                    <td className="p-3 font-medium text-white">{r.referred_name}</td>
                    <td className="p-3 text-zinc-400">{r.referred_email}</td>
                    <td className="p-3">
                      {r.status === 'completed' ? (
                        <Badge className="bg-green-500/20 text-green-400 text-[10px]"><CheckCircle className="h-3 w-3 mr-1" />Concluída</Badge>
                      ) : (
                        <Badge className="bg-amber-500/20 text-amber-400 text-[10px]"><Clock className="h-3 w-3 mr-1" />Pendente</Badge>
                      )}
                    </td>
                    <td className="p-3 text-zinc-500 text-xs">{r.created_at?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
